<template>
  <div class="revue-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Revue de l’École : Culture – Foi – Raison
      </h2>

      <!-- Contenu principal -->
      <div class="content-text max-w-4xl mx-auto text-gray-800 leading-relaxed">
        <p class="mb-4">
          « Culture, Foi et Raison » exprime une ambition de l’Ecole d’Initiation Théologique et Pastorale (EITP), 
          dont elle porte la vision : il s’agit d’une réflexion non éthérée mais plutôt incarnée comme proposition 
          de réponses aux divers défis africains, sans rejet des autres.
        </p>

        <p class="mb-4">
          Elle est une revue qui intègre des publications scientifiques dans une approche pluridisciplinaire sur 
          les grands enjeux sociaux, politiques et ecclésiaux de l’Afrique, à partir de la foi et de ses implications.
        </p>

        <p class="mb-4">
          Aussi, une invitation à des analyses critiques sur diverses questions face aux situations du monde post-moderne !
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReVu", 
  setup() {
    return {};
  },
});
</script>

<style scoped>
.revue-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

h2 {
  color: #2b3a67;
}

.content-text p {
  margin-bottom: 1rem;
}
</style>
